import {OrderEventStore} from "../store/event/OrderEventStore";
import {OrderEventType} from "../models/events/OrderEventType";
import {PlacedOrdersStore} from "../store/placed/PlacedOrdersStore";
import {OrderViewModel} from "../models/OrderViewModel";
import {
    isSameOrder,
    placedBrokerOrder,
    PlacedOrder,
    PlacedOrders,
    placedSimulatedOrder
} from "../store/placed/models/PlacedOrder";
import {isIressOrderModel} from "../models/iress/IressOrderViewModel";
import {isSimulatedOrderModel} from "../models/simulated/SimulatedOrderViewModel";
import {ArrayUtil} from "../../js/util/ArrayUtil";
import {isUserEvent} from "./util/OrderEventUtil";

const NotificationThrottleSeconds = 5;
const NotificationThrottleTime = NotificationThrottleSeconds * 1000;

export class OrderNotificationService {

    public static id = "orderNotificationService";

    private readonly audio = new Audio("assets/sound/bigbox.mp3");

    /** @ngInject */
    public constructor(private readonly orderEventStore: OrderEventStore,
                       private readonly placedOrdersStore: PlacedOrdersStore) {
    }

    public start() {
        this.watchOrderFill();
    }

    private watchOrderFill() {
        this.orderEventStore
            .events(OrderEventType.COMPLETED)
            .withLatestFrom(this.placedOrdersStore.placed)
            .filter(([order, placed]) => isUserEvent(order, placed))
            .map(([e]) => e)
            .map((e) => e.order)
            .throttleTime(NotificationThrottleTime)
            .subscribe(() => this.audio.play());
    }
}
